function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30 8h50a4 4 0 0 1 4 4v53H30V8Z",
  fill: "#D8DDEB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15 12a4 4 0 0 1 4-4h47a4 4 0 0 1 4 4v53H15V12Z",
  fill: "#EAEEF4"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 65,
  width: 84,
  height: 4,
  rx: 2,
  fill: "#F5F8FA"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 30,
  width: 24,
  height: 14,
  rx: 4,
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 34,
  y: 33,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#D8DDEB"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 38,
  y: 33,
  width: 4,
  height: 8,
  rx: 2,
  fill: "#D8DDEB"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 44,
  y: 33,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#D8DDEB"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 33,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#D8DDEB"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M65 27c-5.53 0-10 4.47-10 10s4.47 10 10 10 10-4.47 10-10-4.47-10-10-10Zm4.295 12.885a.997.997 0 1 1-1.41 1.41L65 38.41l-2.885 2.885a.997.997 0 1 1-1.41-1.41L63.59 37l-2.885-2.885a.997.997 0 1 1 1.41-1.41L65 35.59l2.885-2.885a.997.997 0 1 1 1.41 1.41L66.41 37l2.885 2.885Z",
  fill: "#FF6562"
});

function SvgOnePackageWithBarcodeNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 77,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = React.forwardRef(SvgOnePackageWithBarcodeNotFound);
export default __webpack_public_path__ + "static/media/one-package-with-barcode-not-found.276ab329.svg";
export { ForwardRef as ReactComponent };